<template>
    <div v-if="isPurchasePubliclyAvailable">
        <cabinet-fl44-card-info-link :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: purchase.id } }" icon="search">Информация о закупке</cabinet-fl44-card-info-link>
        <cabinet-fl44-card-info-link v-if="purchase.flags.has_actual_proposals" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: purchase.id }, hash: '#atmo-proposals' }" icon="dynamic">Динамика предложений</cabinet-fl44-card-info-link>
        <cabinet-fl44-card-info-link v-if="purchase.flags.has_selected_supplier" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: purchase.id }, hash: '#atmo-supplier-info' }" icon="small_helmet">Итоговый протокол</cabinet-fl44-card-info-link>
        <cabinet-fl44-card-info-link v-if="purchase.flags.has_contract_info" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: purchase.id }, hash: '#atmo-contract' }" icon="grey_contract"> Контракт </cabinet-fl44-card-info-link>
        <cabinet-fl44-card-info-link v-if="purchase.flags.has_contract_fulfillment_info" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: purchase.id }, hash: '#atmo-contract-fulfillment' }" icon="grey_file_small">Исполнение договора</cabinet-fl44-card-info-link>
    </div>
</template>

<script>
import CabinetFl44CardInfoLink from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-info-link.vue';

export default {
    name: 'cabinet-fl44-unknown-volume-card-info-links',
    components: { CabinetFl44CardInfoLink },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isPurchasePubliclyAvailable() {
            return !this.purchase.status.stage.includes('non_public');
        }
    }
};
</script>
